import React from "react"
import { AutocompleteSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { ACRISS_GROUP_BY_OPTIONS } from "@constants"
import { array, object } from "yup"

const SHEETS_ERROR = "Must select at least one sheet"

// the granularity sheets of the One Way workbook; the same axis names the analyzer uses
export default function SheetsField() {

	const {
		sheets,
		setSheetsInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().sheets,
		"sheets",
		object({ sheets: array().required(SHEETS_ERROR).min(1, SHEETS_ERROR) })
	)

	return <AutocompleteSeeker
		multiple
		label="Sheets to generate"
		placeholder="Select the sheets of the workbook"
		options={ACRISS_GROUP_BY_OPTIONS}
		value={sheets || []}
		error={error}
		onChange={e => setSheetsInfo(e.target.value)}
	/>
}
